// import '../Styles/BuyVilla.css'

// import '../Styles/SalaAdertise.css';

// export default function BuyVilla() {
//     return (
//         <div className='Buyvilla-Container'>
//             <div className='Buyvilla-left-image'></div>
//             <div className='Buyvilla-right-text'>
//                 <div className='Buyvilla-heading-Text-container'>
//                     <div className='Buyvilla-Text-hr-line'></div>
//                     <h1>INTERIORS</h1>
//                 </div>
//                 <h1 className='Buyvilla-right-h1'>Superior Style</h1>
//                 <p className='Buyvilla-right-p'>
//                     Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normally evolved from generation X is on the runway heading towards.
//                 </p>
//                 <a className="Buyvilla-right-btn" href="#">View More →</a>
//             </div>
//         </div>
//     );
// }

import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import EnquirePopup from './EnquirePopUp';

import '../Styles/BuyVilla.css';
import '../Styles/SalaAdertise.css';

export default function BuyVilla() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  return (
    <div className='Buyvilla-Container'>
      <div className='Buyvilla-left-image' data-aos="fade-right"></div>

      <div className='Buyvilla-right-text' data-aos="fade-left">
        <div
          className='Buyvilla-heading-Text-container'
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          {/* <div className='Buyvilla-Text-hr-line'></div>
          <h1>INTERIORS</h1> */}
        </div>

        <h1 className='Buyvilla-right-h1' data-aos="fade-up" data-aos-delay="200">
          Own a Coffee Estate with Heritage Resort
        </h1>

        <p className='Buyvilla-right-p' data-aos="fade-up" data-aos-delay="300">
          Welcome to a lifestyle where heritage meets harvest. At Sala, you own more than land — you become part of a nature-rooted, income-generating ecosystem. With an 11th-century-inspired heritage resort at its heart, Sala is set to redefine South India’s hospitality landscape.        </p>
        <p className='Buyvilla-right-p' data-aos="fade-up" data-aos-delay="300">
          At its heart lies the Sala Kalyani — a breathtaking stepwell that serves as the centrepiece for immersive cultural experiences and timeless destination weddings, making Sala one of the most sought-after venues for themed, period celebrations.
        </p>

        <button
          className='Buyvilla-right-btn'
          onClick={() => setShowPopup(true)}
          data-aos="fade-up"
          data-aos-delay="400"
        >
          Know More →
        </button>
      </div>

      <EnquirePopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
    </div>
  );
}
